import { Component, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Atribute, PotentialCustomer } from './model/potential-customer';
import { SesionService } from 'src/app/core/service/sesion.service';
import { PotentialCustomerService } from './service/potential-customer.service';
import { LocationInfo } from 'src/app/shared/model/locatation-intefarce';
import { MapModel } from 'src/app/shared/components/molecules/map/model/map-model';
import { ShadowScrollService } from 'src/app/core/service/utils/shadow-scroll.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MatDialog } from '@angular/material/dialog';
import { noEmojisValidator } from 'src/app/core/service/utils/regex-list.regex';

@Component({
  selector: 'app-potential-customer',
  templateUrl: './potential-customer.component.html',
  styleUrls: ['./potential-customer.component.scss'],
})
export class PotentialCustomerComponent implements OnInit {
  customerForm: FormGroup;
  submitted: boolean;
  loading: boolean;
  sesionData: PotentialCustomer | null;
  isMobile: boolean;

  @Output()
  onComplete = new EventEmitter<number>();

  constructor(
    private fb: FormBuilder,
    private sesion: SesionService,
    private service: PotentialCustomerService,
    public shadowScroll: ShadowScrollService,
    private deviceService: DeviceDetectorService,
    public dialog: MatDialog,
  ) {
    this.submitted = false;
    this.loading = false;

    this.sesionData = this.sesion.getItem('potential_customer');
    this.customerForm = this.fb.group({
      location: [this.sesionData ? this.sesionData.location : '', [Validators.required, noEmojisValidator]],
      fantasyName: [
        this.sesionData ? this.sesionData.fantasyName : '',
        [Validators.required, Validators.maxLength(40)],
      ],
    });
    this.isMobile = this.deviceService.isMobile();
  }
  ngOnInit(): void {
    setTimeout(() => {}, 1500);
  }

  onSubmit() {
    if (!this.loading) {
      this.submitted = true;
      let data = this.createPotentialCustomerDTO();
      let locationInfo = this.getInfoLocation(data.location);
      let province = data.location.state.toLocaleUpperCase();
      if (province.includes('PROVINCE')) {
        province = province.replace(' PROVINCE', ''); // "SANTA FE"
      }
      data.location.state = province;
      if (this.customerForm.valid) {
        // const dialog = this.dialog.open(MapConfirmComponent, {
        //   width: '100vh',
        //   height: height,
        //   disableClose: false,
        //   data: {
        //     coordinates: data.location.coordinates,
        //     address: data.location.street,
        //   },
        // });
        // dialog.afterClosed().subscribe((mapConfirmResponse: MapConfirmationDto) => {
        //   if (mapConfirmResponse) {
        //     let locationInfo = this.getInfoLocation(data.location);
        //     data.location.street = mapConfirmResponse.street;
        //     data.location.coordinates = mapConfirmResponse.coordinates;
        //     console.log('nuevos datos:', data);
        //     this.sesion.setItem<PotentialCustomer>('potential_customer', data);
        //     this.service.validateCP(locationInfo).subscribe((data) => {
        //       this.sesion.setItem<Atribute[]>('atribute', data);
        //     });
        //     this.formComplete();
        //   }
        // });
        this.sesion.setItem<PotentialCustomer>('potential_customer', data);
        this.service.validateCP(locationInfo).subscribe((data) => {
          this.sesion.setItem<Atribute[]>('atribute', data);
        });
        this.formComplete();
      }
    }
  }

  formComplete() {
    this.onComplete.emit(2);
  }

  getInfoLocation(locationData: MapModel): LocationInfo {
    let infoLocation: LocationInfo = {
      city: locationData.city,
      state: locationData.state,
    };
    return infoLocation;
  }

  createPotentialCustomerDTO(): PotentialCustomer {
    let data: PotentialCustomer = {
      location: this.customerForm.controls['location'].value,
      fantasyName: this.customerForm.controls['fantasyName'].value,
    };
    return data;
  }

  @HostListener('scroll', ['$event'])
  onScroll(e: any) {
    this.shadowScroll.scroll(e);
  }
}
